import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';
import { EthemeProvider } from '../../providers/etheme/etheme';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'hat',
  templateUrl: 'hat.html',
})

export class HatComponent {

  private _precent = 0;
  @Input()
  set percent(value: any) {

    if (value == undefined || value == null || value == '') {
      this._precent = 1;
      this.percentuale = 265 - (265 / 100 * this._precent);
      return;
    }
    if (value == 0 || value == '0') {
      this._precent = 1;
      this.percentuale = 265 - (265 / 100 * this._precent);
      return;
    }
    this._precent = value;
    this.percentuale = 265 - (265 / 100 * this._precent);
    // console.log(this._precent);
  }

  get percent() {
    return this._precent;
  }


  numeroxx: any;
  totalexx: any
  pic: any = null; 
  @Input('startcolor') startcolor: string;
  @Input('endcolor') endcolor: string;
  @Input('strokecolor') strokecolor: string;

  @Input('numerox') set numerox(value: string) {
    this.intnumerox = { lower: 0, upper: parseInt(value) };
    this.numeroxx = value;
  }
  @Input('totalex') set totalex(value: string) {
    this.inttotalex = parseInt(value);
    this.totalexx = value;
  }
  @Input('dim') set dim(value: string) {
    this.pic = value;
  }
  percentuale: any = 0;
  rand: any;
  rand2: any;
  gradientname: any;
  intnumerox = { lower: 0, upper: 100 };
  inttotalex = 0;

  constructor(public events: Events, public etheme: EthemeProvider, public injector: Injector) {
    // this.inttotalex = parseInt(this.totalex);
    // this.intnumerox = { lower: 0, upper: 3 };
    // parseInt(this.numerox)
  }
  update_output() {
    //  this.events.publish('aperta', this.domanda, this.risp);
  }
  ngOnInit() {
    
    // this.intnumerox = { lower: 0, upper: 3 };
    // this.inttotalex = parseInt(this.totalex);

    //var per = 100 - this.percent;
    //this.percentuale = per + '%';
    //this.percentuale = 261 /100 *(100-this.percent);
    //this.percentuale = (100-this.percent)+'%';
    //var x = percent.numero / completati.totale * 100
    // console.log(this._percent);

    //this.percentuale = 265-(265/100*this.percent);
    this.rand = Math.floor(Math.random() * 1000);
    this.gradientname = 'Gradient-' + this.rand;
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.

  }
  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.

  }


}



// WEBPACK FOOTER //
// ./src/pages/component/hat.ts